(ns dre.pages.annotator.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.common.document-util :refer [process-response]]
   [dre.network :as-alias network]
   [dre.utils :refer [stringify-keys-with-namespaces]]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path :annotator)

(def response-filter
  {:id true
   :uri true
   :source true
   :subjects {:filter/default {:subject-id true :phrase true}}
   :document/nodes
   {:node/text true
    :annotations {:subject-id true :selection true
                  :is-suggestion true :tags true
                  :ds-tags true :tuis true
                  :sentence-index true}}
   :guid-map true
   :article/tags true
   :article/meta true})

;;events

(rf/reg-event-fx
 ::update-settings
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [skip-pico? use-excerpt-mode?]]
  {:db (assoc-in db [:settings]
                 {:skip-classification skip-pico?
                  :mode/unbound-mode? use-excerpt-mode?})}))

(rf/reg-event-fx
 ::update-input-text
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [input-text]]
  {:db (assoc-in db [:input-text] input-text)}))

(rf/reg-event-fx
 ::set-selected-option-frequency
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [selected-option-frequency]]
  {:db (assoc-in db [:data :selected-option-frequency] selected-option-frequency)}))

(rf/reg-event-fx
 ::annotate
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} _]
  {:db (-> db
           (assoc-in [:state] :loading)
           (assoc-in [:data] {}))
   ::network/request [{:endpoint :annotator/annotate}
                      {:body (stringify-keys-with-namespaces (merge (::settings db)
                                                                    {:article/tags ["flag/predict-participants"]
                                                                     :document/nodes [{:node/text (get db :input-text "")}]
                                                                     :response/filter response-filter})) 
                       :on-success [::success-annotate]
                       :on-failure [::failure-annotate]}]}))

(rf/reg-event-fx
 ::success-annotate
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  (let [resp-body (:body response)]
    {:db (-> db
             (assoc :state :success)
             (assoc-in [:data :response] resp-body)
             (assoc-in [:data :results]
                       (process-response
                        nil
                        {:annotation (first (:document/nodes resp-body))
                         :subjects (:subjects resp-body)
                         :guid-map (:guid-map resp-body)
                         :report? true})))})))

(rf/reg-event-fx
 ::failure-annotate
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  {:db (-> db
           (assoc-in [:state] :failure))
   :dispatch-n [[:dre.network/default-failure opts]]}))


;;subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (db-path db)))

(rf/reg-sub
 ::get-settings
 :<- [::state]
 (fn [state _]
   (get state :settings {})))

(rf/reg-sub
 ::get-input-text
 :<- [::state]
 (fn [state _]
   (get state :input-text "")))

(rf/reg-sub
 ::loading?
 :<- [::state]
 (fn [state _]
   (= :loading (get state :state))))

(rf/reg-sub
 ::response
 :<- [::state]
 (fn [state _]
   (get-in state [:data :response] {})))

(rf/reg-sub
 ::results
 :<- [::state]
 (fn [state _]
   (get-in state [:data :results] {})))

(rf/reg-sub
 ::selected-option-frequency
 :<- [::state]
 (fn [state [_ options]]
   (get-in state [:data :selected-option-frequency] (first options))))